import {
  type AuthorizedResourceAccessMap,
  grantTenantAdminAccess,
} from './permissions/adapter';

export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        isTenantAdmin?: boolean;
      }
    | undefined,
): AuthorizedResourceAccessMap {
  const access = initialState?.authorizedResourceAccess || {};
  return initialState?.isTenantAdmin ? grantTenantAdminAccess(access) : access;
}
